// App.js
import { BrowserRouter } from 'react-router-dom';
import Routes from './routes/Routes';
import FeedbackModal from './components/FeedbackModal';
import './assets/scss/Saas.scss';

const App = () => {
  return (
    <BrowserRouter>
      <FeedbackModal />
      <Routes />
    </BrowserRouter>
  );
};

export default App;
